import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Edit2, Trash2, Utensils } from "lucide-react";

export function RecipesTab({ recipes, onEdit, onDelete }) {
  if (recipes.length === 0) {
    return (
      <Card>
        <CardContent className="py-12 text-center">
          <Utensils className="w-12 h-12 mx-auto text-muted-foreground mb-4" />
          <p className="text-muted-foreground">Sin fichas tecnicas. Vincula ingredientes a tus productos!</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="grid gap-3">
      {recipes.map(r => (
        <Card key={r.product_id} data-testid={`recipe-${r.product_id}`}>
          <CardContent className="p-4">
            <div className="flex items-center justify-between mb-3">
              <div>
                <h3 className="font-semibold text-lg">{r.product_name}</h3>
                <p className="text-sm text-muted-foreground">
                  Precio: {r.product_price?.toFixed(2)}EUR | Coste: {r.total_cost?.toFixed(2)}EUR
                </p>
              </div>
              <div className="flex items-center gap-3">
                <div className="text-right">
                  <p className={`text-xl font-bold ${r.margin_pct >= 60 ? "text-emerald-500" : r.margin_pct >= 40 ? "text-yellow-500" : "text-red-500"}`}>
                    {r.margin_pct}%
                  </p>
                  <p className="text-xs text-muted-foreground">margem</p>
                </div>
                <div className="flex gap-1">
                  <Button variant="ghost" size="icon" onClick={() => onEdit(r)}>
                    <Edit2 className="w-4 h-4" />
                  </Button>
                  <Button variant="ghost" size="icon" onClick={() => onDelete(r.product_id)}>
                    <Trash2 className="w-4 h-4 text-red-500" />
                  </Button>
                </div>
              </div>
            </div>
            <div className="flex flex-wrap gap-2">
              {r.ingredients?.map((ing, i) => (
                <Badge key={i} variant="secondary" className="text-xs">
                  {ing.ingredient_name}: {ing.quantity} {ing.unit} ({ing.cost?.toFixed(2)}EUR)
                </Badge>
              ))}
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
